import { Box, Skeleton, Typography, Grid2 as Grid } from '@mui/material'

const HealthSectionSkeleton = () => {
  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h6' sx={{ marginBottom: 2 }}>
        <Skeleton width={200} />
      </Typography>
      <Grid container spacing={2}>
        <Grid size={3}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Skeleton variant='circular' width={120} height={120} />
            <Skeleton width={80} height={20} sx={{ marginTop: 2 }} />
            <Skeleton width={60} height={16} sx={{ marginTop: 1 }} />
          </Box>
        </Grid>
        <Grid container size={8}>
          {new Array(6).map((_, index) => (
            <Grid size={4} key={'skeleton-' + index}>
              <Box
                sx={{
                  // background: '#f5f5f5',
                  borderRadius: 2,
                  padding: 2,
                  boxShadow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'start'
                }}
              >
                <Skeleton width={150} height={20} />
                <Skeleton width={40} height={30} sx={{ marginTop: 1 }} />
                <Skeleton width={80} height={16} sx={{ marginTop: 1 }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  )
}

export default HealthSectionSkeleton
